export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9868.9d09716d.jpg";